import React from 'react';

const AboutPage = () => {
  const stats = [
    { value: '50,000+', label: 'Chemicals Listed' },
    { value: '2,500+', label: 'Verified Suppliers' },
    { value: '120+', label: 'Countries Served' },
    { value: '10+', label: 'Years Experience' }
  ];

  const team = [
    {
      name: 'Carlos Rodriguez',
      role: 'CEO & Founder',
      bio: '20+ years in chemical industry',
      image: 'https://images.unsplash.com/photo-1472099625385-965a57e3a14c?w=200&h=200&fit=crop'
    },
    {
      name: 'Sarah Chen',
      role: 'CTO',
      bio: 'Former tech lead at major e-commerce platform',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop'
    },
    {
      name: 'Rajesh Patel',
      role: 'Head of Operations',
      bio: 'Supply chain expert with global network',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop'
    },
    {
      name: 'Yuki Tanaka',
      role: 'Head of Quality',
      bio: 'Quality assurance specialist',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ff7ad6d?w=200&h=200&fit=crop'
    }
  ];

  const values = [
    {
      icon: '🔒',
      title: 'Trust & Safety',
      description: 'All suppliers are verified and chemicals are quality-tested'
    },
    {
      icon: '⚡',
      title: 'Efficiency',
      description: 'Streamlined sourcing process saves time and reduces costs'
    },
    {
      icon: '🌍',
      title: 'Global Reach',
      description: 'Access suppliers and buyers from around the world'
    },
    {
      icon: '💚',
      title: 'Sustainability',
      description: 'Committed to promoting sustainable chemical practices'
    }
  ];

  return (
    <div className="about-page">
      <div className="container">
        {/* Hero Section */}
        <section className="hero-section">
          <h1 className="hero-title">
            Connecting the <span className="highlight">Chemical Industry</span>
          </h1>
          <p className="hero-subtitle">
            AsiaQuimicos is the leading B2B marketplace connecting chemical buyers with verified suppliers across Asia and beyond.
          </p>
          <div className="hero-stats">
            {stats.map((stat, i) => (
              <div key={i} className="hero-stat">
                <span className="stat-value">{stat.value}</span>
                <span className="stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Mission Section */}
        <section className="mission-section">
          <div className="mission-content">
            <h2>Our Mission</h2>
            <p>
              To revolutionize chemical sourcing by providing a transparent, efficient, and reliable platform that connects businesses with quality chemical suppliers worldwide.
            </p>
            <p>
              We believe that every business deserves access to high-quality chemicals at fair prices, with the assurance of safety and compliance.
            </p>
          </div>
          <div className="mission-image">
            <img
              src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=600&h=400&fit=crop"
              alt="Chemical industry"
            />
          </div>
        </section>

        {/* Values Section */}
        <section className="values-section">
          <h2>Our Values</h2>
          <div className="values-grid">
            {values.map((value, i) => (
              <div key={i} className="value-card">
                <span className="value-icon">{value.icon}</span>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Team Section */}
        <section className="team-section">
          <h2>Leadership Team</h2>
          <div className="team-grid">
            {team.map((member, i) => (
              <div key={i} className="team-card">
                <img src={member.image} alt={member.name} />
                <h3>{member.name}</h3>
                <span className="role">{member.role}</span>
                <p className="bio">{member.bio}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Certifications */}
        <section className="certifications-section">
          <h2>Certifications & Compliance</h2>
          <div className="certifications-grid">
            <div className="cert-card">
              <span className="cert-icon">✓</span>
              <span className="cert-name">ISO 9001:2015</span>
              <span className="cert-desc">Quality Management</span>
            </div>
            <div className="cert-card">
              <span className="cert-icon">✓</span>
              <span className="cert-name">REACH Compliant</span>
              <span className="cert-desc">EU Chemical Regulations</span>
            </div>
            <div className="cert-card">
              <span className="cert-icon">✓</span>
              <span className="cert-name">GMP Certified</span>
              <span className="cert-desc">Good Manufacturing Practice</span>
            </div>
            <div className="cert-card">
              <span className="cert-icon">✓</span>
              <span className="cert-name">ISO 14001</span>
              <span className="cert-desc">Environmental Management</span>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <h2>Ready to transform your chemical sourcing?</h2>
          <p>Join thousands of businesses already using AsiaQuimicos</p>
          <div className="cta-buttons">
            <button className="btn btn-primary btn-lg">Get Started Free</button>
            <button className="btn btn-outline btn-lg">Contact Sales</button>
          </div>
        </section>
      </div>

      <style jsx>{`
        .about-page {
          padding: var(--space-xl) 0 var(--space-3xl);
        }

        section {
          margin-bottom: var(--space-3xl);
        }

        /* Hero Section */
        .hero-section {
          text-align: center;
          padding: var(--space-3xl) 0;
        }

        .hero-title {
          font-size: var(--font-5xl);
          font-weight: 700;
          color: var(--color-neutral-50);
          margin-bottom: var(--space-lg);
          line-height: 1.2;
        }

        .highlight {
          background: linear-gradient(135deg, var(--color-accent-400), var(--color-accent-300));
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .hero-subtitle {
          font-size: var(--font-xl);
          color: var(--color-neutral-400);
          max-width: 700px;
          margin: 0 auto var(--space-2xl);
        }

        .hero-stats {
          display: flex;
          justify-content: center;
          gap: var(--space-2xl);
          flex-wrap: wrap;
        }

        .hero-stat {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .hero-stat .stat-value {
          font-size: var(--font-3xl);
          font-weight: 700;
          color: var(--color-accent-400);
        }

        .hero-stat .stat-label {
          font-size: var(--font-sm);
          color: var(--color-neutral-500);
        }

        /* Mission Section */
        .mission-section {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: var(--space-2xl);
          align-items: center;
        }

        .mission-content h2 {
          font-size: var(--font-3xl);
          color: var(--color-neutral-50);
          margin-bottom: var(--space-lg);
        }

        .mission-content p {
          font-size: var(--font-lg);
          color: var(--color-neutral-400);
          line-height: 1.8;
          margin-bottom: var(--space-md);
        }

        .mission-image {
          border-radius: var(--radius-xl);
          overflow: hidden;
        }

        .mission-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        /* Values Section */
        .values-section {
          text-align: center;
        }

        .values-section h2 {
          font-size: var(--font-3xl);
          color: var(--color-neutral-50);
          margin-bottom: var(--space-xl);
        }

        .values-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: var(--space-lg);
        }

        .value-card {
          padding: var(--space-xl);
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: var(--radius-lg);
          text-align: center;
          transition: all var(--transition-base);
        }

        .value-card:hover {
          transform: translateY(-4px);
          border-color: var(--color-accent-400);
        }

        .value-icon {
          font-size: 2.5rem;
          margin-bottom: var(--space-md);
        }

        .value-card h3 {
          font-size: var(--font-lg);
          color: var(--color-neutral-50);
          margin-bottom: var(--space-sm);
        }

        .value-card p {
          font-size: var(--font-sm);
          color: var(--color-neutral-400);
        }

        /* Team Section */
        .team-section {
          text-align: center;
        }

        .team-section h2 {
          font-size: var(--font-3xl);
          color: var(--color-neutral-50);
          margin-bottom: var(--space-xl);
        }

        .team-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: var(--space-lg);
        }

        .team-card {
          padding: var(--space-lg);
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: var(--radius-lg);
          text-align: center;
        }

        .team-card img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          margin-bottom: var(--space-md);
          object-fit: cover;
        }

        .team-card h3 {
          font-size: var(--font-lg);
          color: var(--color-neutral-50);
          margin-bottom: var(--space-xs);
        }

        .team-card .role {
          font-size: var(--font-sm);
          color: var(--color-accent-400);
          margin-bottom: var(--space-sm);
        }

        .team-card .bio {
          font-size: var(--font-xs);
          color: var(--color-neutral-500);
        }

        /* Certifications */
        .certifications-section {
          text-align: center;
        }

        .certifications-section h2 {
          font-size: var(--font-3xl);
          color: var(--color-neutral-50);
          margin-bottom: var(--space-xl);
        }

        .certifications-grid {
          display: flex;
          justify-content: center;
          gap: var(--space-lg);
          flex-wrap: wrap;
        }

        .cert-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: var(--space-lg);
          background: rgba(16, 185, 129, 0.1);
          border: 1px solid rgba(16, 185, 129, 0.3);
          border-radius: var(--radius-lg);
          min-width: 180px;
        }

        .cert-icon {
          font-size: 1.5rem;
          color: var(--color-success);
          margin-bottom: var(--space-sm);
        }

        .cert-name {
          font-size: var(--font-base);
          font-weight: 600;
          color: var(--color-neutral-100);
        }

        .cert-desc {
          font-size: var(--font-xs);
          color: var(--color-neutral-500);
        }

        /* CTA Section */
        .cta-section {
          text-align: center;
          padding: var(--space-3xl);
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(6, 182, 212, 0.2));
          border: 1px solid rgba(59, 130, 246, 0.3);
          border-radius: var(--radius-xl);
        }

        .cta-section h2 {
          font-size: var(--font-3xl);
          color: var(--color-neutral-50);
          margin-bottom: var(--space-sm);
        }

        .cta-section p {
          font-size: var(--font-lg);
          color: var(--color-neutral-400);
          margin-bottom: var(--space-xl);
        }

        .cta-buttons {
          display: flex;
          justify-content: center;
          gap: var(--space-md);
        }

        .btn-lg {
          padding: var(--space-md) var(--space-xl);
          font-size: var(--font-base);
        }

        @media (max-width: 1024px) {
          .mission-section {
            grid-template-columns: 1fr;
          }

          .values-grid,
          .team-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 768px) {
          .hero-title {
            font-size: var(--font-3xl);
          }

          .hero-stats {
            gap: var(--space-lg);
          }

          .values-grid,
          .team-grid {
            grid-template-columns: 1fr;
          }

          .cta-buttons {
            flex-direction: column;
            align-items: center;
          }
        }
      `}</style>
    </div>
  );
};

export default AboutPage;
